export enum BankFeedsSupportedRutterPlatforms {
  INTUIT_BANK_FEEDS = "INTUIT_BANK_FEEDS",
  PLAID_BANK_FEEDS = "PLAID_BANK_FEEDS",
  SAGE_BANK_FEEDS = "SAGE_BANK_FEEDS",
  YODLEE_BANK_FEEDS = "YODLEE_BANK_FEEDS",
}
